import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-57bb4c2b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "task-detail" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "task-detail-til" }, "AI预警信息", -1))
const _hoisted_3 = { class: "task-detail-info" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("查看视频")
const _hoisted_5 = {
  key: 0,
  class: "task-detail-title"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "问题", -1))
const _hoisted_7 = {
  key: 1,
  class: "task-detail-score"
}
const _hoisted_8 = { class: "task-detail-num" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", { class: "task-detail-score" }, "分", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "task-detail-margin" }, "|", -1))
const _hoisted_11 = {
  key: 2,
  class: "task-detail-span"
}
const _hoisted_12 = {
  type: "primary",
  size: "mini",
  class: "custom-tag",
  style: {"background-color":"rgb(245, 236, 230)","color":"#fd6304","margin-bottom":"10px"}
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "task-detail-title" }, "基础信息", -1))
const _hoisted_14 = { class: "task-detail-form" }
const _hoisted_15 = { class: "task-detail-item" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "task-detail-label" }, "门店", -1))
const _hoisted_17 = { class: "task-detail-item" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "task-detail-label" }, "所属区域", -1))
const _hoisted_19 = { class: "task-detail-item" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "task-detail-label" }, "通道号", -1))
const _hoisted_21 = { class: "task-detail-item" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "task-detail-label" }, "巡查人", -1))
const _hoisted_23 = { class: "task-detail-item" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "task-detail-label" }, "发生时间", -1))
const _hoisted_25 = { class: "task-detail-item" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "task-detail-label" }, "提交时间", -1))
const _hoisted_27 = { class: "task-detail-item" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "task-detail-label" }, "是否需要整改", -1))
const _hoisted_29 = {
  class: "custom-tag",
  style: {"background-color":"rgb(245, 236, 230)","color":"#fd6304","margin-bottom":"10px"}
}
const _hoisted_30 = {
  key: 0,
  class: "task-detail-prompt"
}

import { ref, reactive } from 'vue'
import { useRoute } from 'vue-router'
import { getRecordDetail } from '@/api/shop'
import ComHeader from '@/components/ComHeader/index.vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const showPicker = ref(false)
const activeNames = ref(['1'])
const detail = ref<any>({})
const activeName = ref(0)

const getScore = (list: any) => {
  return list
    .map((item: any) => item.scoreChange)
    .reduce((a: any, b: any) => a + b)
}

const getAllNumber = () => {
  let number = 0
  detail.value.groupRecordList.forEach((item: any) => {
    item.itemListMap.map((item2: any) => {
      number += item2.itemQuestionsList.length
    })
  })
  return number
}

const getAllScore = (list: any) => {
  return list
    .map((item: any) => {
      return item.itemQuestionsList
        .map((item2: any) => item2.scoreChange)
        .reduce((a: any, b: any) => a + b)
    })
    .reduce((a: any, b: any) => a + b)
}

const route = useRoute()
if (route.query?.id) {
  getRecordDetail(route.query.id as string).then((res: any) => {
    detail.value = res
  })
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_van_collapse_item = _resolveComponent("van-collapse-item")!
  const _component_van_collapse = _resolveComponent("van-collapse")!
  const _component_van_tab = _resolveComponent("van-tab")!
  const _component_van_tabs = _resolveComponent("van-tabs")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ComHeader, {
      height: 16,
      title: 
      detail.value.recordStatus === '1' || detail.value.recordStatus === '2'
        ? '待整改'
        : '已完成'
    
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, "异常事件：" + _toDisplayString(detail.value.eventMessage), 1),
        _createVNode(_component_RouterLink, {
          class: "task-detail-video",
          to: `/retrospect/video/${detail.value.id}?type=task`
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _createVNode(_component_van_image, {
        class: "task-detail-image",
        fit: "cover",
        radius: "8",
        src: detail.value.picUrl
      }, null, 8, ["src"]),
      (detail.value.groupRecordList && detail.value.groupRecordList[0])
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("span", {
              class: "task-detail-desc",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (showPicker.value = true))
            }, [
              _createTextVNode(" 全部" + _toDisplayString(getAllNumber()) + "个问题 ", 1),
              _createVNode(_component_van_icon, {
                class: "task-select-icon",
                name: "arrow",
                size: "12",
                color: "#999"
              })
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_van_popup, {
        show: showPicker.value,
        "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => ((showPicker).value = $event)),
        "close-icon": "close",
        closeable: "",
        round: "",
        position: "bottom",
        style: { minHeight: '30%', maxHeight: '80%' }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_van_tabs, {
            active: activeName.value,
            "onUpdate:active": _cache[2] || (_cache[2] = ($event: any) => ((activeName).value = $event)),
            style: {"margin":"35px 0 -15px"}
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detail.value.groupRecordList, (item) => {
                return (_openBlock(), _createBlock(_component_van_tab, {
                  key: item.id,
                  title: `${item.groupName}(${getAllScore(item['itemListMap'])})`
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_van_collapse, {
                      modelValue: activeNames.value,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((activeNames).value = $event)),
                      style: {"margin":"15px 2px 8px"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item['itemListMap'], (item2, index) => {
                          return (_openBlock(), _createBlock(_component_van_collapse_item, {
                            name: index,
                            title: `${item2.itemName}(${getScore(item2.itemQuestionsList)})`,
                            key: item2.id
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_van_cell_group, null, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item2.itemQuestionsList, (item3) => {
                                    return (_openBlock(), _createBlock(_component_van_cell, {
                                      key: item3.questionId,
                                      title: item3.questionName,
                                      value: item3.scoreChange
                                    }, null, 8, ["title", "value"]))
                                  }), 128))
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1032, ["name", "title"]))
                        }), 128))
                      ]),
                      _: 2
                    }, 1032, ["modelValue"])
                  ]),
                  _: 2
                }, 1032, ["title"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["active"])
        ]),
        _: 1
      }, 8, ["show"]),
      (detail.value.groupRecordList && detail.value.groupRecordList[0])
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, [
              _createTextVNode(_toDisplayString(detail.value.score) + " ", 1),
              _hoisted_9
            ]),
            _hoisted_10,
            _createTextVNode(" " + _toDisplayString(detail.value.groupRecordList[0]['groupName']), 1)
          ]))
        : _createCommentVNode("", true),
      (detail.value.groupRecordList && detail.value.groupRecordList[0])
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, _toDisplayString(detail.value.groupRecordList[0]['itemListMap'][0]['itemQuestionsList'][0][
            'scoreChange'
          ]) + "分 ", 1),
            _createElementVNode("div", null, _toDisplayString(detail.value.groupRecordList[0]['itemListMap'][0]['itemQuestionsList'][0][
            'questionName'
          ]), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", null, [
        _hoisted_13,
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createTextVNode(" " + _toDisplayString(detail.value.storeName), 1)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createTextVNode(" " + _toDisplayString(detail.value.areaName), 1)
          ]),
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createTextVNode(" " + _toDisplayString(detail.value.channelNo), 1)
          ]),
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createTextVNode(" " + _toDisplayString(detail.value.createName), 1)
          ]),
          _createElementVNode("div", _hoisted_23, [
            _hoisted_24,
            _createTextVNode(" " + _toDisplayString(detail.value.processTime), 1)
          ]),
          _createElementVNode("div", _hoisted_25, [
            _hoisted_26,
            _createTextVNode(" " + _toDisplayString(detail.value.createTime), 1)
          ]),
          _createElementVNode("div", _hoisted_27, [
            _hoisted_28,
            _createElementVNode("div", _hoisted_29, _toDisplayString(detail.value.isReform === '1' ? '需整改' : '无需整改'), 1)
          ]),
          (detail.value.recordStatus === '1' || detail.value.recordStatus === '2')
            ? (_openBlock(), _createElementBlock("div", _hoisted_30, " 提示：待整改任务进入海康/大华app查看并整改。 "))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 64))
}
}

})